import { render, staticRenderFns } from "./BuddhismWorkbench.vue?vue&type=template&id=4a36fc64&scoped=true"
import script from "./BuddhismWorkbench.vue?vue&type=script&lang=js"
export * from "./BuddhismWorkbench.vue?vue&type=script&lang=js"
import style0 from "./BuddhismWorkbench.vue?vue&type=style&index=0&id=4a36fc64&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a36fc64",
  null
  
)

export default component.exports